/**
 * presentations/components/pages/ActionDetails.tsx
 */

import { CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useGetVersion, useInvoiceSummary } from 'src/use-cases/invoice/useInvoices';

import { LandingTopWidget } from '../../organisms/landing';
import { LayoutSidebar } from '../../organisms/sidebar/LayoutSidebar';
import { InvoiceContextProvider } from '../../organisms/actionDetails/InvoiceContextProvider';
import { ShipmentSelector } from '../../organisms/actionDetails/ShipmentSelector';
import { NoRateCardSelector } from '../../organisms/actionDetails/noRateCard/Selector';
import ActionDetailsMainContent from '../../organisms/actionDetails/MainContent';
import { DisputeSelector } from '../../organisms/actionDetails/dispute/Selector';
import { UploadModalSelector } from '../../organisms/actionDetails/UploadDocument/UploadModalSelector';

const ActionDetailsPage: React.FC = () => {
  const { id } = useParams();

  const { data: dataVersion, isLoading: isLoadingVersion } = useGetVersion(id, true);
  const { data: invoiceSummary, isLoading: isLoadingSummary } = useInvoiceSummary(id);

  const isShowLoading = isLoadingSummary || isLoadingVersion;

  // Show layout with loading spinner inside content area while loading
  if (isShowLoading || !invoiceSummary) {
    return (
      <>
        <LandingTopWidget />
        <LayoutSidebar>
          <div className='flex-1 flex items-center justify-center min-h-[400px] bg-neutral-10'>
            <CircularProgress color='primary' />
          </div>
        </LayoutSidebar>
      </>
    );
  }

  return (
    <InvoiceContextProvider key={id} invoiceSummary={invoiceSummary} version={dataVersion}>
      <ShipmentSelector>
        <NoRateCardSelector>
          <DisputeSelector>
            <UploadModalSelector>
              <ActionDetailsMainContent />
            </UploadModalSelector>
          </DisputeSelector>
        </NoRateCardSelector>
      </ShipmentSelector>
    </InvoiceContextProvider>
  );
};

export default ActionDetailsPage;
